import script from "./Component-01.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-01.vue?vue&type=script&setup=true&lang=js"

import "./Component-01.vue?vue&type=style&index=0&id=346e9b4d&lang=scss"

const __exports__ = script;

export default __exports__